(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/components/section.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/components/section.js');
'use strict';

const Fieldset = svs.ui.reactForm.Fieldset;

const Section = _ref => {
  let title = _ref.title,
    children = _ref.children;
  return React.createElement(React.Fragment, null, React.createElement("h3", {
    className: "h3 margin-bottom-1"
  }, React.createElement("span", {
    className: "f-medium"
  }, title)), React.createElement(Fieldset, {
    legend: title,
    srOnly: true
  }, children));
};
svs.myProfile.react.pages.notifications.components.Section = Section;

 })(window);